import { mapInfo, RADAR_SIZE, type Level, type MapId } from "./catalog.ts";

/** A point on the radar, from 0 to 1 across and down (left, top = 0). */
export interface RadarPoint {
  u: number;
  v: number;
}

/** World X/Y (game units) to a point on the radar. */
export function worldToRadar(id: MapId, x: number, y: number): RadarPoint {
  const m = mapInfo(id);
  return {
    u: (x - m.posX) / m.scale / RADAR_SIZE,
    v: (m.posY - y) / m.scale / RADAR_SIZE,
  };
}

/** A point on the radar back to world X/Y. */
export function radarToWorld(id: MapId, p: RadarPoint): { x: number; y: number } {
  const m = mapInfo(id);
  return {
    x: m.posX + p.u * RADAR_SIZE * m.scale,
    y: m.posY - p.v * RADAR_SIZE * m.scale,
  };
}

/** Which radar a height belongs to. Single-level maps are always "upper". */
export function levelAt(id: MapId, z: number | null | undefined): Level {
  const m = mapInfo(id);
  if (m.lowerBelowZ === undefined || z === null || z === undefined) return "upper";
  return z < m.lowerBelowZ ? "lower" : "upper";
}

export const hasLowerLevel = (id: MapId) => mapInfo(id).lowerBelowZ !== undefined;

/** True when a radar point falls on the image. */
export const onRadar = (p: RadarPoint) => p.u >= 0 && p.u <= 1 && p.v >= 0 && p.v <= 1;
